<div class="main text-center" [ngClass]="themeService.currentPalette">
    <div class="box">
    <h1>¡Felicidades!</h1>
    <p class="lead mt-4">Su pago se ha procesado exitosamente.</p>
    <img class="congrat" src="../../../assets/icons/congratulations-icon.gif" alt="Felicidades">
    <p>Redireccionando en {{ countdown }} segundos...</p>
    <img src="../../assets/images/grafica2.png" alt="graff">
    </div>
  </div>
  